import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Image } from 'react-bootstrap';
import { Player } from 'video-react';
import ReactJson from 'react-json-view';
import PropTypes from 'prop-types';

import { fetchSourceMediaFileIfOK, clearSourceMediaPreviewValues } from '../../actions';

class MediaPreview extends Component {
    constructor (props) {
        super(props);
    }    

    componentDidMount() {
        const {mediaURL, fetchSourceMediaFileIfOK} = this.props;
        const ext = mediaURL.split('.').pop();

        // We have to fetch JSONs and load them from redux :(
        if (ext === 'json') {
            fetchSourceMediaFileIfOK(mediaURL);
        }
    }

    componentWillReceiveProps(nextProps) {
        const {mediaURL, fetchSourceMediaFileIfOK} = nextProps;
        const ext = mediaURL.split('.').pop();

        // We have to fetch JSONs and load them from redux :(
        if (ext === 'json') {
            fetchSourceMediaFileIfOK(mediaURL);
        }
    }

    componentWillUnmount() {
        const {clearSourceMediaPreviewValues} = this.props;
        clearSourceMediaPreviewValues();
    }

    render () {
        const {mediaURL, previewBlob, noPreviewMessage, mediaRowObject} = this.props;
        const ext = mediaURL.split('.').pop();
        
        var data = {
            Scene: mediaRowObject.sceneName,
            Dataset: mediaRowObject.datasetNum,
            MediaName: mediaRowObject.mediaName,
            Language: mediaRowObject.language,
            Samples: 0.1
        };

        switch (ext) {
            case 'png':
            case 'jpg':
                return (<Image src={mediaURL} responsive />);
    
            case 'wav':
            case 'mp3':
            case 'ogg':
                return (<div className="audio-preview">
                            <div><audio src={mediaURL} controls /></div>                            
                        </div>);
    
            case 'mov':
            case 'mp4':
                return (<Player fluid autoPlay playsInline src={mediaURL} />);
            
            case 'json':
                if (previewBlob) {
                    const json = JSON.parse(new TextDecoder('utf-8').decode(previewBlob));
                    return (<ReactJson src={json} collapsed={2}/>);
                } else {
                    return 'Loading JSON...';
                }

            default:
                return noPreviewMessage;
            
        }
    }
}

const mapDispatchToProps = {
    fetchSourceMediaFileIfOK,
    clearSourceMediaPreviewValues
};

const mapStateToProps = state => {
    const previewBlob = state.ui.previewMedia.previewData;
    const mediaRowObject = state.ui.previewMedia.mediaRowObject;

    return {
        previewBlob,
        mediaRowObject
    };
};

MediaPreview.propTypes = {
    mediaURL:                      PropTypes.string.isRequired,
    noPreviewMessage:              PropTypes.string.isRequired,
    fetchSourceMediaFileIfOK:      PropTypes.func.isRequired,
    clearSourceMediaPreviewValues: PropTypes.func.isRequired,
    previewBlob:                   PropTypes.any,
    mediaRowObject: PropTypes.object.isRequired
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MediaPreview);



// WEBPACK FOOTER //
// ./src/components/mediaPreview/MediaPreview.js